module.exports = __webpack_public_path__ + "static/media/flower.130ffc5f.svg";